<template>
  <div class="record">
    <Header></Header>
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">     
    <van-list
      class="recordList"
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <div class="recordList-item" v-for="(item,index) in recordList" :key="index">
        <div>
          <div>
            <p>购买{{item.integral}}积分</p>
            <div>{{item.childName}}</div>
          </div>
          <div>{{item.createTime}}</div>
        </div>
        <div>+{{item.integral}}积分</div>
      </div>
    </van-list>
     </van-pull-refresh>
  </div>
</template>

<script>
import { getShoppingRecord } from "../api/api-order";
import { List } from "vant";
import Header from "../components/Header";
export default {
  components: {
    Header
  },
  data() {
    return {
      isLoading: false,
      loading: false,
      finished: false,
      recordList:[],
      pageNum:1,
      pageSize:10,
      hasNextPage:false
    };
  },
  computed: {},
  watch: {},
  methods: {
      onLoad() {
      // 异步更新数据
      setTimeout(() => {
       if(this.hasNextPage){
         this.pageNum++;
         this.getRecordList()
       }
        // 加载状态结束
        this.loading = false;

        // 数据全部加载完成
       
          this.finished = true;
        
      }, 500);
    },
    getRecordList(){
      let params={
          pageNumber:this.pageNum,
          pageSize:this.pageSize
      }
      getShoppingRecord(params).then(res=>{
        if(res.code==200){
           this.hasNextPage=res.data.hasNextPage;
           this.recordList=this.pageNum==1?res.data.list:this.recordList.concat(res.data.list)          
        }
      })
    },
    onRefresh() {
      setTimeout(() => {
        this.$toast('刷新成功');
        this.isLoading = false;
        this.pageNum=1;
        this.getRecordList()
      }, 500);
    }
  },
  created() {
    this.getRecordList()
  },
  mounted() {}
};
</script>
<style scoped lang="less">
// /deep/ .van-pull-refresh{
//   height: 100%;
//   box-sizing: border-box;
//   .van-pull-refresh__track{
//     height: 100%;
//   }
// }
.record {
  height: 100vh;
  background: #ecf0f5;
  box-sizing: border-box;
  .recordList {
    background: #fff;
    // padding-left: 15px;
    .recordList-item {
      display: flex;
      justify-content: space-between;
      padding: 12px 14px 12px 15px;
      border-bottom: 1px solid #e2e4e8;
      & > div:first-child {
        & > div:first-child {
          display: flex;
          align-items: center;
          p {
            color: #333;
          }
          div {
            width: 50px;
            height: 22px;
            border-radius: 8px;
            border: 1px solid #87e2cd;
            color: #87e2cd;
            font-size: 12px;
            line-height: 22px;
            text-align: center;
            margin-left: 5px;
          }
        }
        & > div:last-child {
          font-size: 12px;
          color: #999;
          margin-top: 2px;
        }
      }
      & > div:last-child {
        color: #f59323;
      }
      &:last-of-type {
        border-bottom: none;
      }
    }
  }
 /deep/ .van-list__finished-text{
      background: #ECF0F5;
  }
}
</style>